import CoursePreview from './container'
export default CoursePreview
